module.exports = __webpack_public_path__ + "static/media/Shop.21a51792.gif";